'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (TestimonialSwitcher, $) {
		var $dom = {};

		var cacheDom = function cacheDom() {
			$dom.testimonialSwitcher = $('[data-testimonial-options]');
			$dom.testimonialSlider = $('[data-testimonial-slider]');
		};

		var TestimonialSwitcherInit = function TestimonialSwitcherInit(current) {
			var testimonialType = current.attr('data-handle');
			current.addClass('active').siblings().removeClass('active');
			$dom.testimonialSlider.removeClass('active');
			$dom.testimonialSlider.each(function () {
				var sliderType = $(this).attr('data-handle');
				if (sliderType == testimonialType) {
					$(this).addClass('active');
					$(this).slick('refresh');
				}
			});
		};

		var bindUIActions = function bindUIActions() {
			$dom.testimonialSwitcher.on('click', 'li', function () {
				TestimonialSwitcherInit($(this));
			});
		};

		TestimonialSwitcher.init = function () {
			cacheDom();
			bindUIActions();
		};
	})(window.TestimonialSwitcher = window.TestimonialSwitcher || {}, _jquery2.default, undefined);
};